import React, { useState, useEffect } from 'react';
import EVENT_TYPE from '../../utilities/EventType';

export default (props) => {
    useEffect(() => {
        try {
            window.analytics.track(EVENT_TYPE.NEW_REVISION_MODAL, {
                userId: window.userId,
                teamId: window.teamId,
            });
        } catch (e) {
            console.error(e, 'analytics blocked');
        }
    }, []);

    const [showModal, setShowModal] = useState(true);
    if (!showModal) return null;

    const onClick = ({ target }) => {
        const className = target.getAttribute('class');
        if (className && className.includes('react-modal open')) {
            setShowModal(false);
        }
    };

    return (
        <div className="react-modal open" onMouseDown={onClick}>
            <div className="modal-content">
                <h2>Draft updated</h2>
                <div>
                    <p>
The page
                        <b>{props.title}</b>
                        {' '}
has been updated since you viewed it. We have updated you to the latest version of the page.
                    </p>
                </div>
                <div className="mt2 right-align">
                    <span className="btn-secondary mr1" onClick={() => setShowModal(false)}>Ok, thanks!</span>
                </div>
            </div>
        </div>
    );
};
